import actionTypes from '../../action-types'

export default (customerId, payload) => ({
  type: actionTypes.CUSTOMER_PRODUCTS.CREATE,
  payload,
  meta: { customerId },
})
